import { type Meta } from '../types/docs';
import { ONBOARDING_ANALYTICS_CATEGORIES } from './onboardingAnalytics';

const META: Meta = {
  description: 'User submitted a context domain',
  name: 'context_domain_submitted',
  params: [
    {
      description: 'The domain that was submitted',
      name: 'domain',
      required: true,
      type: 'string',
    },
    {
      description: 'Where the domain was submitted from',
      name: 'source',
      required: true,
      type: 'enum',
      values: [...ONBOARDING_ANALYTICS_CATEGORIES, 'manual'],
    },
  ],
};

export default META;
